import { useUserData } from '../contexts/UserDataContext';

export function FundingHistoryTab() {
  const { fundingHistory, isConnected, isInitialLoad } = useUserData();

  const showEmptyState = !isConnected || (isInitialLoad && fundingHistory.length === 0) || fundingHistory.length === 0;
  const emptyMessage = !isConnected
    ? 'Connect wallet to view funding history'
    : isInitialLoad && fundingHistory.length === 0
    ? 'Loading funding history...'
    : 'No funding history';

  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}/${day}/${year} - ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className="h-full bg-[#0e0f10]">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#1a1d20]">
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Time
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Coin
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Size
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Position
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Payment
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Rate
            </th>
          </tr>
        </thead>
        <tbody>
          {showEmptyState ? (
            <tr>
              <td colSpan={6} className="px-3 py-8 text-center text-[#6c7884] text-[13px]">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            fundingHistory.map((entry, idx) => {
              const payment = parseFloat(entry.usdc);
              const size = parseFloat(entry.szi);
              const rate = parseFloat(entry.fundingRate) * 100; // Convert to percentage
              const isLong = size > 0;
              const absSize = Math.abs(size);

              return (
                <tr key={idx} className="hover:bg-[#13141a] transition-colors">
                  <td className="px-3 py-3 text-[#6c7884] text-[12px]">
                    {formatTime(entry.time)}
                  </td>
                  <td className="px-3 py-3 text-white font-medium text-[12px]">
                    {entry.coin}
                  </td>
                  <td className="px-3 py-3 text-white text-[12px]">
                    {absSize.toFixed(4)} {entry.coin}
                  </td>
                  <td className="px-3 py-3">
                    <span className={`text-[12px] font-medium ${
                      isLong ? 'text-[#0ecb81]' : 'text-[#f6465d]'
                    }`}>
                      {isLong ? 'Long' : 'Short'}
                    </span>
                  </td>
                  <td className={`px-3 py-3 text-right text-[12px] ${
                    payment >= 0 ? 'text-[#0ecb81]' : 'text-[#f6465d]'
                  }`}>
                    {payment >= 0 ? '+' : ''}{payment.toFixed(4)} USDC
                  </td>
                  <td className={`px-3 py-3 text-right text-[12px] ${
                    rate >= 0 ? 'text-[#0ecb81]' : 'text-[#f6465d]'
                  }`}>
                    {rate >= 0 ? '+' : ''}{rate.toFixed(4)}%
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
